import { IonButton, IonButtons, IonContent, IonHeader, IonInput, IonItem, IonLabel, IonList, IonNote, IonSpinner, IonTitle, IonToolbar } from "@ionic/react";
import { t } from "i18next";
import React, { useContext, useState } from "react";
import { AuthenticatedUserContext } from "../../contexts/AuthenticatedUserContext";
import { ApiService } from "../../services";

export const ChangeEmailModal = (props: any) => {
  const [newEmail, setNewEmail] = useState<any>("");
  const [password, setPassword] = useState<any>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [errors, setErrors] = useState<any>({});
  const { member } = useContext(AuthenticatedUserContext);

  const confirm = () => {
    setIsLoading(true);

    ApiService.post("members/" + member!.id + "/account/change-email", {
      password,
      email: newEmail,
    })
      .then(() => {
        setIsLoading(false);
        setErrors({});
        props.onSuccess();
      })
      .catch((response) => {
        setIsLoading(false);
        setErrors(response.errors);
      });
  };

  return (
    <>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonButton onClick={() => props.onDismiss()}>{t("cancel")}</IonButton>
          </IonButtons>
          <IonTitle>{t("changeEmail")}</IonTitle>
          <IonButtons slot="end">
            {isLoading ? (
              <IonSpinner name={"dots"} />
            ) : (
              <IonButton strong={true} onClick={confirm} disabled={!password || !newEmail}>
                {t("change")}
              </IonButton>
            )}
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent className="ion-padding">
        <IonList inset={true}>
          <IonItem className={errors.email ? "ion-invalid" : ""}>
            <IonLabel>{t("email")}</IonLabel>
            <IonInput disabled={isLoading} onIonChange={(e) => setNewEmail(e.target.value)} placeholder={t("newEmail") || ""} type={"email"}></IonInput>
            {errors.email && <IonNote slot={"error"}>{errors.email?.map((er: string, index: number) => <div key={"email-" + index}>{er}</div>)}</IonNote>}
          </IonItem>

          <IonItem className={errors.password ? "ion-invalid" : ""}>
            <IonLabel>{t("password")}</IonLabel>
            <IonInput disabled={isLoading} onIonChange={(e) => setPassword(e.target.value)} placeholder={t("enterPassword") || ""} type={"password"}></IonInput>
            {errors.password && <IonNote slot={"error"}>{errors.password?.map((er: string, index: number) => <div key={"new-" + index}>{er}</div>)}</IonNote>}
            {!errors.password && <IonNote slot={"helper"}>{t("changeEmailPasswordExplainer")}</IonNote>}
          </IonItem>
        </IonList>

        <div className={"ion-margin-top"}>
          <IonNote>{t("changeEmailNote")}</IonNote>
        </div>
      </IonContent>
    </>
  );
};
